import Vue from "vue";
const templateId = +document.body.getAttribute("tplid") || document.body.getAttribute("data-tplid");
const templatePath = "./components/templates/" + templateId + "/App.js";
const newGroupElement = document.querySelector('[data-is-new-group]');
let isNewGroup = false;

if (newGroupElement) {
  isNewGroup = newGroupElement.dataset.isNewGroup === '1' ? true : false;
}
import allrazdel from './components/allrazdel.js'
import statusrazdel from './components/statusrazdel.js'
import options from './components/options.js'
import firstfindblock from './components/firstfindblock.js'
import findbutton from './components/findbutton.js'
import { graphFilterGroup, graphFilerOptions } from './components/graphql.js'
import axios from 'axios'


let component = Vue.component("App", function(resolve, reject) {
  import(`${templatePath}`).then(res => {
    resolve({
      template: res.default,
      watch: {
        testhtml: function(){
          setTimeout(function(){
            if(window.changeViewProductsToList){
              if(localStorage.getItem('view') == 'list'){
                window.changeViewProductsToList()
              }else{
                window.changeViewProductsToGrid()
              }
            }
          },250)
        },
      },
      mounted() {
        let x = window.location.href
        this.sp = this.jsonval.allrazdel
        if (x.indexOf('group_id=') > 0) {
          this.urlValue = x
          this.hideRazdel = false
          this.showOptions = true
          this.sp = this.jsonval.allrazdel
          let text = this.urlValue.substring(this.urlValue.indexOf('group_id'))
          let first = this.urlValue.substring(this.urlValue.indexOf('group_id')).indexOf('=')
          let last = null
          if (this.urlValue.substring(this.urlValue.indexOf('group_id')).indexOf('&') === -1) {
            last =  this.urlValue.substring(this.urlValue.indexOf('group_id')).length
          } else {
            last = this.urlValue.substring(this.urlValue.indexOf('group_id')).indexOf('&')
          }
          let res = parseInt(text.substring(first + 1, last))
          this.groupid = res
        }
        this.findVal = document.querySelector('input[name=find_val]').value
        let pageSizeInput = document.querySelector('input[name=page_size]')
        let charsetInput = document.querySelector('input[name=charset]')
        this.page_size = pageSizeInput ? +pageSizeInput.value : ((this.templateId==35 || this.templateId==42) ? 15 : 12)
        this.charset = charsetInput ? charsetInput.value : ''
        this.$nextTick(function() {
          this.$nextTick(function() {
            this.words = document.querySelector('input[name=main_words]').value
            this.words = this.words.split(',')
            this.jsonval = {
              "allrazdel": this.words[0],
              "from": this.words[1],
              "to": this.words[2],
              "keyphrase": this.words[3],
              "price": this.words[4],
              "product": this.words[5],
              "isproductexist": this.words[6],
              "inrazdel": this.words[7],
              "anychoice": this.words[8],
              "dobutton": this.words[9],
              "clearbutton": this.words[10],
              "compare": this.words[11],
              "sortBy": this.words[12],
              "pageSize": this.words[13],
              "noSort": this.words[14],
              "priceUp": this.words[15],
              "priceDown": this.words[16],
              "wordsUp": this.words[17],
              "wordsDown": this.words[18],
              "isSale": this.words[19] || this.getSaleText()
            }
            this.singlesel = this.jsonval.noSort
            this.formSubmit();
          })
        })
        setTimeout(function(){
          if(window.changeViewProductsToList){
            if (localStorage.getItem('view')) {
              if (localStorage.getItem('view') == 'list') {
                window.changeViewProductsToList();
              } else {
                window.changeViewProductsToGrid();
              }
            } else {
              if (!window.TWIG_DATA_JS) return;
              if (window.TWIG_DATA_JS.get('productCardsViewType') === 'list') {
                window.changeViewProductsToList();
              } else {
                window.changeViewProductsToGrid();
              }
            }
          }
        },250)
      },
      computed: {
        page_product_count() {
          return ((this.product_count + this.page_size - 1) - (this.product_count + this.page_size - 1) % this.page_size) / this.page_size
        },
        spVal() {
          if (this.ordersElement && this.ordersElement.name) {
            return this.ordersElement.name
          }
        },
      },
      data() {
        return {
          templateId:templateId,
          isNewGroup: isNewGroup,
          sp: '',
          hideRazdel: false,
          showOptions: false,
          page_size: 12,
          affb:true,
          afb:true,
          isAc:true,
          groupid: 0,
          orders: [],
          jsonval: '',
          loading: 0,
          loadingElement: 0,
          filterGroupFilter: {"ids":[]},
          urlValue: '',
          findVal: '',
          ischcked: true,
          classtrue: 'ok-filter-search -mb-article-half ok-menu__first-lvl -state-open',
          classfalse: 'ok-filter-search -mb-article-half ok-menu__first-lvl',
          getFindData:{},
          testhtml: '',
          sort: '',
          page_num: 1,
          product_count: 0,
          step: 2,
          isMounted: 1,
          singlesel: '',
          ordersElement:undefined,
          charset:'',
          contentStyle:{
            opacity: '1',
            transition: 'opacity 0.25s'
          },
        }
      },
      apollo: {
        orders: {
          query: graphFilterGroup,
          loadingKey: 'loading',
          variables() {
            return {
              filter: this.filterGroupFilter
            }
          },
          update: data => data.filterGroup,
          skip() {
              return isNewGroup
          }
        },
        ordersElement: {
          query: graphFilerOptions,
          loadingKey: 'loadingElement',
          variables() {
            return {
              filter: {
                ids:[this.groupid]
              }
            }
          },
          update: data => {
            let obj = data.filterGroup[0]
            if (obj.fields && obj.fields.length) {
              obj.fields.forEach(el => el.typeId === 8 ? el.typeId = 9 : '')
              obj.fields = obj.fields.filter(el => el.options.length)
            }
            return obj
          },
          skip() {
            return this.groupid ? false : true
          }
        }
      },
      methods: {
        isActiveSort(val) {
          if (val === this.sort) {
            return '-state-active'
          }
        },
        isActiveSize(val) {
          if (val === this.page_size) {
            return '-state-active'
          }
        },
        getSaleText(){
          let text = "Товары со скидкой"
          if(document.charset==="windows-1251"){
            var DMap = {0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, 10: 10, 11: 11, 12: 12, 13: 13, 14: 14, 15: 15, 16: 16, 17: 17, 18: 18, 19: 19, 20: 20, 21: 21, 22: 22, 23: 23, 24: 24, 25: 25, 26: 26, 27: 27, 28: 28, 29: 29, 30: 30, 31: 31, 32: 32, 33: 33, 34: 34, 35: 35, 36: 36, 37: 37, 38: 38, 39: 39, 40: 40, 41: 41, 42: 42, 43: 43, 44: 44, 45: 45, 46: 46, 47: 47, 48: 48, 49: 49, 50: 50, 51: 51, 52: 52, 53: 53, 54: 54, 55: 55, 56: 56, 57: 57, 58: 58, 59: 59, 60: 60, 61: 61, 62: 62, 63: 63, 64: 64, 65: 65, 66: 66, 67: 67, 68: 68, 69: 69, 70: 70, 71: 71, 72: 72, 73: 73, 74: 74, 75: 75, 76: 76, 77: 77, 78: 78, 79: 79, 80: 80, 81: 81, 82: 82, 83: 83, 84: 84, 85: 85, 86: 86, 87: 87, 88: 88, 89: 89, 90: 90, 91: 91, 92: 92, 93: 93, 94: 94, 95: 95, 96: 96, 97: 97, 98: 98, 99: 99, 100: 100, 101: 101, 102: 102, 103: 103, 104: 104, 105: 105, 106: 106, 107: 107, 108: 108, 109: 109, 110: 110, 111: 111, 112: 112, 113: 113, 114: 114, 115: 115, 116: 116, 117: 117, 118: 118, 119: 119, 120: 120, 121: 121, 122: 122, 123: 123, 124: 124, 125: 125, 126: 126, 127: 127, 1027: 129, 8225: 135, 1046: 198, 8222: 132, 1047: 199, 1168: 165, 1048: 200, 1113: 154, 1049: 201, 1045: 197, 1050: 202, 1028: 170, 160: 160, 1040: 192, 1051: 203, 164: 164, 166: 166, 167: 167, 169: 169, 171: 171, 172: 172, 173: 173, 174: 174, 1053: 205, 176: 176, 177: 177, 1114: 156, 181: 181, 182: 182, 183: 183, 8221: 148, 187: 187, 1029: 189, 1056: 208, 1057: 209, 1058: 210, 8364: 136, 1112: 188, 1115: 158, 1059: 211, 1060: 212, 1030: 178, 1061: 213, 1062: 214, 1063: 215, 1116: 157, 1064: 216, 1065: 217, 1031: 175, 1066: 218, 1067: 219, 1068: 220, 1069: 221, 1070: 222, 1032: 163, 8226: 149, 1071: 223, 1072: 224, 8482: 153, 1073: 225, 8240: 137, 1118: 162, 1074: 226, 1110: 179, 8230: 133, 1075: 227, 1033: 138, 1076: 228, 1077: 229, 8211: 150, 1078: 230, 1119: 159, 1079: 231, 1042: 194, 1080: 232, 1034: 140, 1025: 168, 1081: 233, 1082: 234, 8212: 151, 1083: 235, 1169: 180, 1084: 236, 1052: 204, 1085: 237, 1035: 142, 1086: 238, 1087: 239, 1088: 240, 1089: 241, 1090: 242, 1036: 141, 1041: 193, 1091: 243, 1092: 244, 8224: 134, 1093: 245, 8470: 185, 1094: 246, 1054: 206, 1095: 247, 1096: 248, 8249: 139, 1097: 249, 1098: 250, 1044: 196, 1099: 251, 1111: 191, 1055: 207, 1100: 252, 1038: 161, 8220: 147, 1101: 253, 8250: 155, 1102: 254, 8216: 145, 1103: 255, 1043: 195, 1105: 184, 1039: 143, 1026: 128, 1106: 144, 8218: 130, 1107: 131, 8217: 146, 1108: 186, 1109: 190}

            function unicodeToWin1251_UrlEncoded(s) {
              var L = []
              for (var i=0; i<s.length; i++) {
                var ord = s.charCodeAt(i)
                if (!(ord in DMap))
                  throw "Character "+s.charAt(i)+" isn't supported by win1251!";
                L.push('%'+DMap[ord].toString(16));
              }
              return decodeURIComponent(L.join('').toUpperCase());
            }
            return unicodeToWin1251_UrlEncoded(text)
          }
          return text
        },
        isActivePage(val) {
          if (val === this.page_num) {
            const id = this.templateId
            return id>35 && id<42 ? '-btn-width-small -btn-theme-alt -state-active' : '-state-active'
          }
        },
        pageButton(val) {
          this.page_num = val
          this.formSubmit()
        },
        sizeButton(val) {
          this.page_num = 1
          this.page_size = val
          this.formSubmit()
        },
        sortButton(val) {
          this.sort = val
          this.page_num = 1
          this.formSubmit()
          switch(val) {
            case '':
              return this.singlesel = this.jsonval.noSort
              break;
            case 'price__number':
              return this.singlesel = this.jsonval.priceUp
              break;
            case 'price__number__desc':
              return this.singlesel = this.jsonval.priceDown
              break;
            case 'name__text':
              return this.singlesel = this.jsonval.wordsUp
              break;
            case 'name__text__desc':
              return this.singlesel = this.jsonval.wordsDown
              break;
            default:
              break;
          }
        },
        formSubmit() {
          let test = this.$refs.formRef
          this.getFindData = new FormData(test);
          this.getFindData.append('sort', this.sort)
          this.getFindData.append('page_num', this.page_num)
          if (this.isMounted) {
            this.getFindData.append('findtext', this.findVal || '')
            this.getFindData.append('charset', this.charset || '')
            let inStockInput = document.querySelector('input[name=inStock]')
            if(inStockInput && +inStockInput.value>0){
              this.getFindData.append('item_status', 1)
            }
            if(document.querySelector('input[name=page_size]')){
              this.getFindData.append('page_size', this.page_size)
            }
          }else{
            this.getFindData.append('page_size', this.page_size)
          }
          this.contentStyle.opacity = '0.5'
          axios.post('/template/find/extended', this.getFindData).then(
            res => {
              this.testhtml = res.data.content
              this.contentStyle.opacity = '1'
              this.product_count = res.data.productCount
              this.page_size = res.data.pageSize
              if (this.isMounted) {
                this.isMounted = 0
              }
              this.$nextTick(function() {
                this.$nextTick(function() {
                  if(window.normalizeProductsView){
                    window.normalizeProductsView()
                  }
                  if (document.querySelector('[data-cart-icon]')) {
                    window.initCart();
                  }
                  window.initProducts();
                })
              })
            }
          )
        },
        spvalue() {
          this.sp = this.jsonval.allrazdel
        },
        hideAndChangeSp(index) {
          if (index === -1) {
            this.sp = this.jsonval.allrazdel
            this.groupid = 0
          } else {
            this.sp = this.orders[index].name;
            this.groupid = this.orders[index].id;
            this.hideRazdel=!this.hideRazdel;
            if (this.isAc) {this.showOptions=true;}
            this.$nextTick(function() {
              this.$apollo.queries.ordersElement.refetch()
            })
          }
        },
        hideDefaultSp() {
          this.sp = this.jsonval.allrazdel;
          this.hideRazdel=!this.hideRazdel;
          this.groupid = 0;
          if (this.isAc) {this.showOptions=true;}
        },
        fstatus() {
          this.affb=!this.affb;
          this.showOptions=!this.showOptions;
          this.afb=!this.afb;
          this.isAc=!this.isAc;
          this.ischcked=!this.ischcked;
        }
      },
      components: {
        appAllRazdel: allrazdel,
        appStatusRazdel: statusrazdel,
        appOptions: options,
        appFisrtFindBlock: firstfindblock,
        appFindButton: findbutton
      }
    });
  });
});
export default component;



// WEBPACK FOOTER //
// ./src/App.js